import { NgModule } from '@angular/core';

import { RepeatDirective } from './repeat-elements.directive';

@NgModule({
  declarations: [
      RepeatDirective,
  ],
  exports: [
      RepeatDirective,
  ]
})
export class DirectiveModule { }
